import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "triangle-down",
  "use": "triangle-down-usage",
  "viewBox": "0 0 767.5 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 767.5 1024\" id=\"triangle-down\"><path d=\"M0 384l383.75 383.75L767.5 384H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol